import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { createSelector } from 'reselect';
import { orderBy } from 'lodash';

const options = {
  name: 'availabilityCodes',
  baseType: 'AVAILABILITY_CODES',
  apiEndpoint: 'availability_codes'
};

const metadataApiSelectors = createMetadataAPISelectors(options);

const sortedCodes = createSelector(metadataApiSelectors.values, availabilityCodes =>
  orderBy(availabilityCodes, ['display_order', 'name'])
);

export const selectSchedulableAvailabilityCodes = createSelector(sortedCodes, availabilityCodes =>
  availabilityCodes.filter(ac => ac.purposes.includes('scheduling'))
);

export const selectForDutyRequest = createSelector(sortedCodes, availabilityCodes =>
  availabilityCodes.filter(ac => ac.purposes.includes('duty_request'))
);

export const selectForBookkeeping = createSelector(sortedCodes, availabilityCodes =>
  availabilityCodes.filter(ac => ac.purposes.includes('bookkeeping'))
);

export const selectForActivityReport = createSelector(sortedCodes, availabilityCodes =>
  availabilityCodes.filter(ac => ac.purposes.includes('activity_report'))
);

export default {
  ...metadataApiSelectors,
  selectSchedulableAvailabilityCodes,
  selectForDutyRequest,
  selectForBookkeeping,
  selectForActivityReport
};
